import { LeftOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React, { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { TitleBackButton } from './styles';

export interface BackButtonProps {
  confirm?: boolean;
  confirmTitle?: string;
  step: number;
  onClick: () => void;
}

const BackButton = (props: BackButtonProps) => {
  const { step, confirm, onClick } = props;
  const { t } = useTranslate();

  const btn = useMemo(() => {
    return (
      <TitleBackButton
        type="text"
        onClick={
          confirm
            ? undefined
            : () => {
                onClick();
              }
        }
      >
        <LeftOutlined />
        {t('authShop.上一步')}
      </TitleBackButton>
    );
  }, [confirm, onClick, t]);

  if (step === 0) return null;

  return confirm ? (
    <Popconfirm
      title={t('authShop.返回上一步将终止当前添加店铺流程，确认返回并重新添加店铺')}
      onConfirm={() => onClick()}
    >
      {btn}
    </Popconfirm>
  ) : (
    btn
  );
};

export default BackButton;
